export const DATE_COLORS = [
  {
    primary: '#FFC107', // Agrifirm yellow
    excluded: '#FFE082',
    name: 'yellow',
  },
  {
    primary: '#007934', // Agrifirm green
    excluded: '#86BC25', // Lighter green for excluded
    name: 'green',
  },
  {
    primary: '#E63946',
    excluded: '#FF8A80',
    name: 'red',
  },
] as const;

export const REFERENCE_COLORS = {
  growthCurveRange: '#fc0',
  averageGrowthCurve: '#b5051b',
} as const;
